
import './App.css'
import React from 'react'
import {Routes, Route} from 'react-router-dom';
import LoginPage from './component/LoginPage';
import Dashboard from './component/Dashboard';
import ActiveUser from './component/Clients/Active.js';
import Multiplier from './component/Clients/Multiplier.js';
import IncompleteUser from './component/Clients/Incomplete.js';
import DeleteRequestUser from './component/Clients/DeleteRequested.js';
import DeletedUser from './component/Clients/Deleted.js';


import Role from './component/URM/Role';
import Module from './component/URM/Module';
import Action from './component/URM/Action';
import User from './component/URM/User';


import InternetActivity from './component/InternetActivity';
import Brand from './component/Brand';
import KPI from './component/KPI';
// import Category from './component/Category';
// import Product from './component/Product';

import BrandKPI from './component/Research/BrandKPI.js';
// import Study from './component/Research/Study.js';
// import Primary from './component/Research/Primary.js';
// import Screener from './component/Research/Screener.js';
// import Report from './component/Research/Report.js';
// import Update from './component/Research/Update.js';
import Variable from './component/Research/Variable.js';

function App() {
  return (
    <div className="App">
      <>     
        <Routes>
          <Route path='/' element={<LoginPage />} />
          <Route path='/dashboard' element={<Dashboard />} />
          <Route path='/clients/active' element={<ActiveUser />} />
          <Route path='/clients/incomplete' element={<IncompleteUser />} />
          <Route path='/clients/delete-request' element={<DeleteRequestUser />} />
          <Route path='/clients/multiplier-request' element={<Multiplier />} />
          <Route path='/clients/deleted' element={<DeletedUser />} />

          
          <Route path='/urm/roles' element={<Role />} />
          <Route path='/urm/modules' element={<Module />} />
          <Route path='/urm/actions' element={<Action />} />
          <Route path='/urm/users' element={<User />} />

          {/* <Route exact path="/" element={<LoginView />}></Route>
          <Route exact path="/signup" element={<SignupView />}></Route> */}
          <Route exact path="/research/brand-kpi" element={<BrandKPI />}></Route>
          <Route exact path="/research/variables" element={<Variable />}></Route>

          <Route path='/internet-activity' element={<InternetActivity />} />
          <Route path='/brand' element={<Brand />} />
          <Route path='/kpi' element={<KPI />} />
          {/* <Route path='/category' element={<Category />} />
          <Route path='/product' element={<Product />} /> */}
          {/* <Route exact path="/research/study" element={<Study />}></Route>
          <Route exact path="/research/primary" element={<Primary />}></Route>
          <Route exact path="/research/screener" element={<Screener />}></Route>
          <Route exact path="/research/report" element={<Report />}></Route>
          <Route exact path="/research/update" element={<Update />}></Route> */}
        </Routes>
      </>
    </div>
  );
}

export default App;
